import { createFileRoute } from '@tanstack/react-router';
import { SeoCompetitorsOrganicPage } from '@/pages/SeoCompetitorsOrganicPage';

export const Route = createFileRoute('/_authed/seo/competitors')({
  component: SeoCompetitorsOrganicPage,
});
